// extracted by mini-css-extract-plugin
export default {"ratingPicker":"StarRating_ratingPicker__mrg5C"};